module.exports = __webpack_public_path__ + "img/sdk-logo.1e547c45.svg";